import Cookies from 'js-cookie';
import { CalculatePadding } from '4-sections/DesktopHeader/DesktopHeader';

const AlertBannerInit = () => {
    const alertBanners = document.querySelectorAll('.alert-banner');

    alertBanners.forEach(banner => {
        const bannerId = banner.id;
        const cookieValue = Cookies.get(bannerId);

        if (!cookieValue || cookieValue !== 'dismissed') {
            banner.classList.remove('dismissed');
            const closeButtons = banner.querySelectorAll('.albnr-close-button');
            closeButtons.forEach(closeButton => {
                closeButton.addEventListener('click', e => {
                    e.preventDefault();
                    banner.classList.add('dismissed');
                    Cookies.set(bannerId, 'dismissed', { expires: 60 });
                    CalculatePadding();
                });
            });
        }
    });
};

document.addEventListener('DOMContentLoaded', AlertBannerInit);
